import NoResults from 'components/NoResults'
import Spinner from 'components/Spinner'
import Table from 'components/Table'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { MerchantTransactionTypes } from 'types/merchant'
import TransactionItem from './TransctionItem'
import TransactionReportFilter from './TransactionReportFilter'
import useMerchantTransaction from '../Transaction/useMerchantTransaction'

const TRANSACTION_COLUMNS = [
  'Trans Date',
  'Trans Id',
  'Ident',
  'Ext Trans Id',
  'Merchant',
  'Trans Type',
  'CR Value',
  'Loyalty Value',
  'Purchase Value',
  'Device Code',
  'Trace No.'
]

function Transactions(): React.ReactElement {
  const [transactionFetchLimitError, setTransactionFetchLimitError] =
    useState(false)
  const [, setMerchantFetchLimitError] = useState(false)
  const [offset, setOffset] = useState(0)
  const [perPage] = useState(1000)
  const [pageCount, setPageCount] = useState(0)
  const [postData, setPostData] = useState<MerchantTransactionTypes[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const { merchantTransaction, merchantTransactionLoading } = useMerchantTransaction()

  useEffect(() => {
    if (merchantTransaction) {
      const slice = merchantTransaction.slice(offset, offset + perPage)
      setPostData(slice)
      setPageCount(Math.ceil(merchantTransaction.length / perPage))
    }
  }, [offset, perPage, merchantTransaction])

  function handlePageClick({ selected }: { selected: number }): void {
    setOffset(selected * perPage)
    setCurrentPage(selected + 1)
  }

  return (
    <div>
      <TransactionReportFilter />

      {transactionFetchLimitError ? (
        <NoResults
          header="Failed to load data"
          subtitle="Please refresh the page and try again, or contact
        your system administrator"
          noImage
        />
      ) : merchantTransactionLoading ? (
        <>
          <NoResults header="Loading" subtitle="Fetching data" noImage />
          <Spinner />
        </>
      ) : (
        <>
          {isEmpty(merchantTransaction) ? (
            <NoResults noImage />
          ) : (
            <Table
              columns={TRANSACTION_COLUMNS}
              data={merchantTransaction}
              pageCount={pageCount}
              currentPage={currentPage}
              perPage={perPage}
              onPageChange={handlePageClick}
              itemCount={postData.length}
              showActions
            >
              {postData.map((item: MerchantTransactionTypes) => (
                <TransactionItem 
                  key={item.transactionId} 
                  transaction={item} 
                />
              ))}
            </Table>
          )}
        </>
      )}
    </div>
  )
}

export default Transactions
